import React, { useEffect } from "react";

import { isRentenbankProgram, useGeneralContext, useGetFarms, useTranslation, useUserContext } from "utils";

import { FEATURE_FLAGS } from "consts";

import { AlertBanner, MainPage } from "components";

import { FeatureFlagGate } from "pages/app/_app/components/feature-flag/FeatureFlagGate";
import ContactFooter from "pages/app/home/components/ContactFooter";
import HomePageFarmList from "pages/app/home/components/HomePageFarmList";
import { HomePagePlanningList } from "pages/app/home/components/HomePagePlanningList.tsx";
import { HomeSubmissionBanner } from "pages/app/home/components/HomeSubmissionBanner";
import OnboardingBanner from "pages/app/home/components/OnboardingBanner";
import { HomeHero } from "pages/app/home/hero/HomeHero";

const Home: React.FC = () => {
  const { t } = useTranslation(["home"]);
  const { setRailNavCollapsed } = useGeneralContext();
  const { user } = useUserContext();
  const { currentFarm, isLoading: isGetFarmsLoading } = useGetFarms();

  const showRentenbankBanner = isRentenbankProgram(currentFarm?.carbonProgram);

  const farmHasFields = !!user?.farm?.fields && user?.farm?.fields > 0;
  const showOnboardingBanner =
    isGetFarmsLoading || !currentFarm?.carbonProgram || !farmHasFields || currentFarm?.carbonProgram.platformFeatures.fieldManagement?.enabled === false;

  useEffect(() => {
    setRailNavCollapsed(true);
  }, [setRailNavCollapsed]);

  const navigationCrumbs = {
    crumbs: [],
  };

  return (
    <MainPage pageName="Home" navigationCrumbs={navigationCrumbs} showMobileAlert>
      {showRentenbankBanner ? (
        <AlertBanner
          closeable
          className="margin-bottom-200"
          type="info"
          iconName="tabler/info-circle"
          iconSize={24}
          iconAlign="start"
          title={t("home:rentenbankBanner.title")}
          description={t("home:rentenbankBanner.description")}
        />
      ) : null}
      {/* the list and the footer wait with the gate, so they don't paint at the top and get pushed down once the flag answers */}
      <FeatureFlagGate flag={FEATURE_FLAGS.NEW_HOMEPAGE_HERO}>
        {(heroEnabled) => (
          <>
            {heroEnabled ? (
              <HomeHero />
            ) : (
              <>
                {showOnboardingBanner ? <OnboardingBanner /> : <HomeSubmissionBanner />}
                <HomePageFarmList />
              </>
            )}
            <HomePagePlanningList />
            <ContactFooter />
          </>
        )}
      </FeatureFlagGate>
    </MainPage>
  );
};

export default Home;
